export const REQUEST_TIMEOUT = 120000;
export const ERROR_TOAST_DURATION = 2000;
export const RETRY_FLAG = "_retry" as const;

/**
 * Bu kodlar bilan kelgan xatoni "qayta urinib ko'rish" mumkin emas: token
 * qayta ishlatilgan (o'g'irlangan bo'lishi mumkin), parol o'zgargani uchun
 * eskirgan, yoki hisob bloklangan. Har uchalasi ham darhol chiqarishni
 * talab qiladi — yangilashga urinish faqat vaqt yo'qotadi.
 */
export const HARD_LOGOUT_ERROR_CODES = new Set([
  "REFRESH_TOKEN_REUSED",
  "TOKEN_STALE",
  "ACCOUNT_BLOCKED",
]);

/** Backend `requestId` ni shu sarlavhada ham qaytaradi (CORS'da ochilgan). */
export const REQUEST_ID_HEADER = "x-request-id";

/**
 * Parametrli xato xabarlari: kod → `ERROR_DETAILS.<CODE>` TALAB QILADIGAN
 * qiymatlar.
 *
 * Ro'yxat lug'atda emas, kodda turadi, chunki qiymat yetib kelmaganda
 * xabar umuman chizilmasligi kerak — yarim to'ldirilgan gap ("Eng ko'pi
 * ta fayl") xatoning o'zidan ham yomonroq. Qiymat yetishmasa
 * `getErrorMessage` hujjatdagi oddiy `ERRORS.<CODE>` ga qaytadi.
 *
 * Kalitlar `details` dan keladi; `<kalit>Count` va `maxSizeLabel` ni
 * `toMessageValues` hisoblab beradi.
 */
export const PARAMETERISED_ERRORS: Record<string, readonly string[]> = {
  VALIDATION_FAILED: ["fieldsCount"],
  BELOW_MINIMUM: ["min"],
  ABOVE_MAXIMUM: ["max"],
  OTP_COOLDOWN: ["retryAfterSeconds"],
  TOO_MANY_LOGIN_ATTEMPTS: ["retryAfterSeconds"],
  COURSE_HAS_ENROLLMENTS: ["enrolledCount"],
  FILE_TOO_LARGE: ["maxSizeLabel"],
  FILE_TYPE_NOT_ALLOWED: ["allowed"],
  INVALID_MIME_TYPE: ["allowed"],
  TOO_MANY_FILES: ["maxFiles"],
  MAX_ATTEMPTS_REACHED: ["max"],
  POINTS_EXCEED_MAX: ["max"],
  SCORE_EXCEEDS_MAX: ["max"],
  QUIZ_NOT_OPEN_YET: ["availableFrom"],
  QUIZ_PAST_DUE: ["dueDate"],
  VIDEO_NOT_WATCHED: ["watchedPercent"],
  GRADE_WEIGHTS_INVALID: ["received"],
};
